export default {
  state: {
    connectors: [],
    connectorsKey: []
  },
  getters: {
    connectors(state) {
      return state.connectors
    },
    connectorsKey(state) {
      return state.connectorsKey
    }
  },
  mutations: {
    setConnectors(state, connectors) {
      state.connectors = connectors
    },
    setConnectorsKey(state, connectorsKey) {
      state.connectorsKey = connectorsKey
    },
    clearConnectors(state) {
      state.connectors = []
    },
    clearConnectorsKey(state) {
      state.connectorsKey = []
    }
  },
  actions: {
    setConnectors({ commit }, connectors) {
      commit('clearError')
      commit('setLoading', true)
      commit('clearConnectors')
      const payload = []
      commit('setConnectorsKey', Object.keys(connectors))
      const keys = Object.keys(connectors)
      for (let key in keys) {
        payload[keys[key]] = connectors[keys[key]]
      }
      commit('setConnectors', connectors)
    },
    clearConnectors({ commit }) {
      commit('clearConnectors')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/connector/index.js